import { makeWorkbook } from "../../utils/excel";
import { getIndicatorStatesCounter } from "../../../../../../rest/indicator";

const STATE_LABELS_PT = {
  APPROVED: "Aprovadas",
  ELIGIBILITY: "Por tratar",
  IN_TREATMENT: "Em tratamento",
  REVOKED: "Revogação",
  REJECTION: "Indeferidas",
  WITHDRAWAL: "Desistência",
  VALIDATION: "Em validação",
  CANCELED: "Anuladas",
};

const labelForState = (key) => STATE_LABELS_PT[key] || key;

export async function buildWorkbookStatus() {
  const resp = await getIndicatorStatesCounter();
  const payload = resp?.data || {};
  const data = Array.isArray(payload?.data) ? payload.data : payload || [];

  const items = (data || []).map((it) => ({
    state: it?.state ?? "",
    counter: Number(it?.counter || 0),
  }));
  const total = items.reduce((s, i) => s + i.counter, 0);
  const sorted = items.slice().sort((a, b) => b.counter - a.counter);
  const pct = (v, t) => (t > 0 ? Number(v) / Number(t) : 0);

  const resumoAoa = [
    ["Indicador", "Valor"],
    ["Total de candidaturas", Number(total || 0)],
    ["Estados distintos", sorted.length],
  ];

  const distAoa = [
    ["Estado (código)", "Estado", "Valor", "% do total"],
    ...sorted.map((i) => [
      i.state,
      labelForState(i.state),
      i.counter,
      pct(i.counter, total),
    ]),
  ];

  return makeWorkbook([
    { name: "Resumo", aoa: resumoAoa },
    { name: "Distribuicao", aoa: distAoa, percentCols: [3] },
  ]);
}
